import { api } from '../../../services/api'

/**
 * Callback for ID Persona.
 *
 * @endpoint POST /api/verify/id/callback
 * @scope shared
 * @see https://flecto.dev/api-4724197
 */
export async function verifyUserIdPersonaCallback(
  httpPersonaSignature: string
): Promise<void> {
  await api.post('/api/verify/id/callback', undefined, {
    headers: { HTTP_PERSONA_SIGNATURE: httpPersonaSignature },
  })
}
